module.exports = __webpack_public_path__ + "img/trading.797d0c68.png";